import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Ei tuotteita vielä.',
  fields: {
    number: '#',
    image: 'Kuva',
    name: 'Nimi',
    external_id: '{{integration}}-viite',
    price: 'Hinta',
    prices: 'Hinnat',
    description: 'Kuvaus',
    tags: 'Tunnisteet',
    status: 'Tila',
    product_type: 'Tyyppi',
    statuses: {
      good: 'Hyvä',
      bad: 'Huono',
      medium: 'Keskitaso',
    },
    product_types: {
      packaged: 'Pakattu',
      prepared: 'Valmistettu',
    },
  },
  labels: {
    visible: 'Näkyvissä valikossa',
    hidden: 'Kaikki piilotettu',
  },
  order_method_prices: {
    base: 'Perus',
    [ORDER_METHODS.pickup]: 'Nouto',
    [ORDER_METHODS.delivery]: 'Toimitus',
    [ORDER_METHODS.room_service]: 'Huone-/pöytäpalvelu',
  },
  buttons: {
    delete_products_one: 'Poista tuote',
    delete_products_other: 'Poista tuotteet',
    add_product: '+ Lisää tuote',
    show_products: 'Näytä tuotteet',
    hide_products: 'Piilota tuotteet',
    add: 'Lisää',
    edit: 'Muokkaa',
    duplicate: 'Monista',
    history: 'Historia',
    delete: 'Poista',
    delete_all: 'Poista kaikki',
  },
  toasts: {
    failed_to_duplicate_category: 'Kategorian monistaminen epäonnistui',
    category_duplicated_successfully: 'Kategoria monistettu onnistuneesti',
    failed_to_duplicate_product: 'Tuotteen monistaminen epäonnistui',
    product_duplicated_successfully: 'Tuote monistettu onnistuneesti',
    failed_to_delete_variant: 'Variantin poistaminen epäonnistui',
    variant_got_deleted: 'Variantti poistettu',
    something_went_wrong: 'Jotain meni pieleen',
  },
};
